import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Header";
import { DashboardFooter } from "../layout/dashboard-ui";
import { Smart } from 'smart-webcomponents-react/grid';
import 'smart-webcomponents-react/source/styles/smart.default.css';
import {
    Box,
    Chip,
    Button,
    TextField,
    Alert,
    FormControl,
    Checkbox,
    Tabs,
    Tab,
    styles as styled,
    Select,
    MenuItem,
    Tooltip,
    IconButton,
    Autocomplete,
    Modal, CircularProgress, Badge,
} from '@mui/material/';
import { useNavigate } from 'react-router-dom';
import "./groupIQ.css";
import { dateDiff, dateFormat, deepCopy, isDateInRange, keyToLabel, convertToPercent, getGroupQouteSettings } from "../../app/util";
import { formatCurrency } from './groupIQHelper'
import { CloseSharp as CloseSharpIcon } from '@mui/icons-material';
import moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { toast } from 'react-toastify';
import DataService from "../../services/data.service";
import { UPDATE_STATE } from '../../actions/types';
import { calculateRoomDetails } from '../GroupPricing/group_pricing_functions';
import dataService, { fetchDataSimple } from '../../services/data.service';
import PropTypes from 'prop-types';
import AncilleryRev from "./AncilleryRev"
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { DemandSeasons, BlackoutDates } from './settingsPopup';
import RoomBlock from "./RoomBlock";
import WishRate from "./WishRate";
import WalkRate from "./WalkRate";
import CustomRate from "./CustomRate";
import { AtuoLogoutTimer } from '../AutoLogoutTimer';
import { Grid } from "react-virtualized";
import { setGroup } from "@amplitude/analytics-browser";
Smart.License = "8414516F";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function GroupIQ() {
    const dispatch = useDispatch();
    const { app, auth } = useSelector((state) => state);
    const { app_state, ui_state } = app.current_state;
    const { as_of_date } = app_state.primary_stay_range;
    const { currency_symbol } = ui_state;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmittingAnyway, setIsSubmittingAnyway] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [arrivalDate, setArrivalDate] = React.useState(as_of_date);
    const [departureDate, setDepartureDate] = React.useState(moment(as_of_date).add(7, 'days').format("YYYY-MM-DD"));
    const [arrivalDateTemp, setArrivalDateTemp] = React.useState(as_of_date);
    const [departureDateTemp, setDepartureDateTemp] = React.useState(moment(as_of_date).add(7, 'days').format("YYYY-MM-DD"));
    const [groupTypeNamePopupOpen, setGroupNameTypePopupOpen] = useState(false);
    const [isGroupTypeNameChanged, setIsGroupTypeNameChanged] = useState(false);
    const otbRmType = useRef([]);
    const initialTabTemplate = { dataSource: [], columnObjs: {}, columnGroupObjs: {}, footerField: {} };
    const roomBlockTabData = useRef({ ...initialTabTemplate });
    const ancillaryRevTabData = useRef({ ...initialTabTemplate });
    const customRateTabData = useRef({ ...initialTabTemplate });
    const wishRateTabData = useRef({ ...initialTabTemplate });

    const totalNightsRef = useRef(null)
    const roomsPerDayRef = useRef(null)
    const totalRevenueRef = useRef(null)
    const totalIncrementalRevenueRef = useRef(null)
    const optimalAcceptableRateRef = useRef(null)
    const revenueExpectedRef = useRef(null)
    const revenueDisplacedRef = useRef(null)

    const groupNameError = useRef(false);
    const groupTypeError = useRef(false);
    const groupNameTypeRequired = useRef(false);
    const topNumber = useRef([{
        tab: 'wish',
        totalNights: 0,
        totalRooms: 0,
        roomsPerDay: 0,
        totalRevenue: 0,
        totalIncrementalRevenue: 0,
        optimalAcceptableRate: 0,
        revenueExpected: 0,
        roomRevenueDisplaced: 0
    }, {
        tab: 'walk',
        totalNights: 0,
        totalRooms: 0,
        roomsPerDay: 0,
        totalRevenue: 0,
        totalIncrementalRevenue: 0,
        optimalAcceptableRate: 0,
        revenueExpected: 0,
        roomRevenueDisplaced: 0
    }, {
        tab: 'custom',
        totalNights: 0,
        totalRooms: 0,
        roomsPerDay: 0,
        totalRevenue: 0,
        totalIncrementalRevenue: 0,
        optimalAcceptableRate: 0,
        revenueExpected: 0,
        roomRevenueDisplaced: 0
    }]);

    // Initial output bottom data
    const [profitMarginText, setProfitMarginText] = useState("");
    const [commissionText, setCommissionText] = useState("");
    const [complimentaryRoomsText, setComplimentaryRoomsText] = useState("");
    const [perPaidRoomText, setPerPaidRoomText] = useState("");
    const addMoreInfoValue = useRef("");
    const addMoreInfoRef = useRef(null);
    const [revenueModifier, setRevenueModifier] = useState({});
    const [profitMargins, setProfitMargins] = useState({});
    const checkFirstRender = useRef(true);
    const sampleResponseData = {
        data: {
            primary: {
                dates: [
                    {
                        date: "2024-10-22",
                        wish: [
                            {
                                room_type: "run_of_house",
                                rooms: 2,
                                rate: 137.0,
                                discount: 0.427,
                                revenue: 274.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 274.0
                            },
                            {
                                room_type: "S1KA",
                                rooms: 1,
                                rate: 137.0,
                                discount: 0.427,
                                revenue: 137.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 137.0
                            },
                            {
                                room_type: "P1KO",
                                rooms: 1,
                                rate: 172.0,
                                discount: 0.372,
                                revenue: 172.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 172.0
                            }
                        ],
                        walk: [
                            {
                                room_type: "run_of_house",
                                rooms: 2,
                                rate: 100.0,
                                discount: 0.582,
                                revenue: 200.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 200.0
                            },
                            {
                                room_type: "S1KA",
                                rooms: 1,
                                rate: 100.0,
                                discount: 0.582,
                                revenue: 100.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 100.0
                            },
                            {
                                room_type: "P1KO",
                                rooms: 1,
                                rate: 135.0,
                                discount: 0.507,
                                revenue: 135.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 135.0
                            }
                        ],
                        wish_room_revenue: 435.0,
                        walk_room_revenue: 115.0,
                        ancillary_revenue: 23
                    },
                    {
                        date: "2024-10-23",
                        wish: [
                            {
                                room_type: "run_of_house",
                                rooms: 2,
                                rate: 147.0,
                                discount: 0.427,
                                revenue: 264.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 264.0
                            },
                            {
                                room_type: "S1KA",
                                rooms: 1,
                                rate: 149.0,
                                discount: 0.427,
                                revenue: 187.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 137.0
                            },
                            {
                                room_type: "P1KO",
                                rooms: 1,
                                rate: 172.0,
                                discount: 0.372,
                                revenue: 172.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 172.0
                            }
                        ],
                        walk: [
                            {
                                room_type: "run_of_house",
                                rooms: 2,
                                rate: 100.0,
                                discount: 0.582,
                                revenue: 200.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 200.0
                            },
                            {
                                room_type: "S1KA",
                                rooms: 1,
                                rate: 100.0,
                                discount: 0.582,
                                revenue: 100.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 100.0
                            },
                            {
                                room_type: "P1KO",
                                rooms: 1,
                                rate: 135.0,
                                discount: 0.507,
                                revenue: 135.0,
                                displaced_revenue: 0.0,
                                incremental_revenue: 135.0
                            }
                        ],
                        wish_room_revenue: 215.0,
                        walk_room_revenue: 316.0,
                        ancillary_revenue: 153
                    }
                ],
                overall: {
                    arrival_date: "2024-10-22",
                    departure_date: "2024-10-24",
                    wish: {
                        rate: 145.75,
                        total_revenue: 1166,
                        room_revenue: 1166,
                        incremental_revenue: 1166,
                        commission_cost: 0
                    },
                    walk: {
                        rate: 108.75,
                        total_revenue: 870,
                        room_revenue: 870,
                        incremental_revenue: 870,
                        commission_cost: 0
                    },
                    ancillary_revenue: 0,
                    displaced_revenue: 0,
                    comp_room_cost: 0
                }
            }
        },
        property_id: 440,
        group_quote_id: "4583dc64-a28e-40f2-9b09-ca3da0bcd95a",
        generated_by_email: "abdus.soyel@synclovis.com",
        generated_at: "2024-10-24T10:33:36.388303",
        params_called_with: {
            as_of_date: "2024-10-17",
            group_name: "test",
            type: "Government",
            dates: [
                {
                    date: "2024-10-22",
                    ancillary: {
                        food_bev: 5,
                        facilities: 4,
                        audio_visual: 6,
                        other: 7,
                        other_1: 1
                    },
                    rooms: [
                        {
                            room_type: "run_of_house",
                            rooms: 2
                        },
                        {
                            room_type: "S1KA",
                            rooms: 1
                        },
                        {
                            room_type: "P1KO",
                            rooms: 1
                        }
                    ]
                },
                {
                    date: "2024-10-23",
                    ancillary: {
                        food_bev: 13,
                        facilities: 16,
                        audio_visual: 23,
                        other: 45,
                        other_1: 56
                    },
                    rooms: [
                        {
                            room_type: "run_of_house",
                            rooms: 2
                        },
                        {
                            room_type: "S1KA",
                            rooms: 1
                        },
                        {
                            room_type: "P1KO",
                            rooms: 1
                        }
                    ]
                }
            ],
            profit_percents: {
                food_bev: 0.3,
                facilities: 0.75,
                audio_visual: 0.7,

                other: 0.45,
                other_1: 0.52
            },
            comp_rooms: {
                rooms: 5,
                per_block: 7
            },
            comission_percent: 11,
            api_version: "v1.1",
            property_id: 440,
            user_id: 32026003,
            token: "Api-Key n6kmQ4x6.mVCaBUcSG6Bz2jL76vyBY2iFK8vHr95N"
        },
        proposal: false,
        meta: {
            e: 2.0889,
            ts: "2024-10-24T10:33:36.408093+00:00"
        },
        status: "success"
    };


    const [responseFromAPI, setResponseFromAPI] = useState(sampleResponseData);

    const { groupIQSettings } = app_state;

    const [openDefault, setOpenDefault] = useState(false);
    const [openSetting, setOpenSetting] = useState(false);
    const [openDefaultSetupAlert, setOpenDefaultSetupAlert] = useState(false);
    const [blackout, setBlackout] = useState([]);
    const settingsDisabledRef = useRef(true);


    const updateFooterData = (data) => {

        const groupIQSettings = data;
        let gIQSDefault = groupIQSettings.hasOwnProperty('default_settings') ? groupIQSettings.default_settings : {};
        let gIQSSeasons = groupIQSettings.hasOwnProperty('seasons') ? groupIQSettings.seasons : [];
        let selectedSeasonsIndex = -1;

        if (gIQSSeasons.length) {
            selectedSeasonsIndex = gIQSSeasons.findIndex(season => {
                return moment(season.start_date).isSameOrBefore(arrivalDate) && moment(season.end_date).isSameOrAfter(arrivalDate)
            });
        }

        let roomBlockFooterField = {};
        if (selectedSeasonsIndex > -1) {
            roomBlockFooterField['complimentaryRooms'] = Number(gIQSSeasons[selectedSeasonsIndex].complimentary_rooms);
            roomBlockFooterField['perPadeRooms'] = Number(gIQSSeasons[selectedSeasonsIndex].per_paid_rooms);
            roomBlockFooterField['commission'] = Number(gIQSSeasons[selectedSeasonsIndex].commission_percentage);
        }
        else if (Object.keys(gIQSDefault).length) {
            roomBlockFooterField['complimentaryRooms'] = Number(gIQSDefault.complimentary_rooms);
            roomBlockFooterField['perPadeRooms'] = Number(gIQSDefault.per_paid_rooms);
            roomBlockFooterField['commission'] = Number(gIQSDefault.commission_percentage);
        }
        setRevenueModifier(roomBlockFooterField);

        let ancillaryRevFooterField = {};
        if (selectedSeasonsIndex > -1 && gIQSSeasons[selectedSeasonsIndex].hasOwnProperty('profitMargins') && Object.keys(gIQSSeasons[selectedSeasonsIndex].profitMargins).length) {
            Object.keys(gIQSSeasons[selectedSeasonsIndex].profitMargins).forEach(key => {
                ancillaryRevFooterField[key] = gIQSSeasons[selectedSeasonsIndex].profitMargins[key];
            })
        }
        else if (gIQSDefault.hasOwnProperty('profitMargins') && Object.keys(gIQSDefault.profitMargins).length) {
            Object.keys(gIQSDefault.profitMargins).forEach(key => {
                ancillaryRevFooterField[key] = gIQSDefault.profitMargins[key];
            })
        }
        setProfitMargins(ancillaryRevFooterField);
    }

    // Effect to update openSetting when openDefault changes
    useEffect(() => {
        if (openDefault) {
            setOpenDefaultSetupAlert(true);
        }
    }, [openDefault]);

    function handleContinueDefaultSetup() {
        setOpenDefaultSetupAlert(false);
        setOpenSetting(true);
    }
    // OLD CODE TO FETCH SETTINGS DATA FROM API
    const getGroupQouteSettings1 = async () => {
        let api = 'rms/properties/group-quote-settings/' + app_state.property_id + "/";
        const payload = { method: 'GET' };
        try {
            const response = await fetchDataSimple({ api, request: payload });
            if (response.status === "success") {
                console.log("Default Season", response.data.default_settings);
                console.log("Seasons", response.data.seasons);
                console.log("Blackout Dates", response.data.blackout_dates);
                setBlackout(response.data.blackout_dates)
                return response;
            } else {
                console.log("Error:", response.message);
                if (response.message == "Group Quote Settings not found") {
                    setOpenDefault(true)
                    localStorage.setItem("isOpenDefault", true);
                    localStorage.setItem("isReload", true);
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // NEW CODE TO FETCH SETTINGS DATA FROM REDUX
    const getGroupQouteSettings2 = () => {
        const response = groupIQSettings;
        if (response.status === "error") {
            console.log("Error:", response.message);
            if (response.message == "Group Quote Settings not found") {
                setOpenDefault(true)
                localStorage.setItem("isOpenDefault", true);
                localStorage.setItem("isReload", true);
            }
        } 
        else {
            console.log("Default Season", response.default_settings);
            console.log("Seasons", response.seasons);
            console.log("Blackout Dates", response.blackout_dates);
            setBlackout(response.blackout_dates)
            setTimeout(() => {
                settingsDisabledRef.current = false;
                updateFooterData(response);
            }, 10);
        }
    };

    useEffect(() => {
        const isGroupSettingsDashboard = localStorage.getItem("isGroupSettingsDashboard");
        if(isGroupSettingsDashboard == 'true') {
            console.log("isGroupSettingsDashboard is true, calling getGroupQouteSettings2")
            getGroupQouteSettings2();
        }
        else {
            console.log("isGroupSettingsDashboard is false, calling getGroupQouteSettings1")
            getGroupQouteSettings1().then((rs) => {
                const data = deepCopy(rs.data);
                dispatch({
                    type: UPDATE_STATE,
                    payload: {
                        app_state: {
                            groupIQSettings: data
                        }
                    }
                });
                // settingsDisabledRef.current = false;
                // updateFooterData(data);
                setTimeout(() => {
                    settingsDisabledRef.current = false;
                    updateFooterData(data);
                }, 10);
            });
        }
    }, []);

    const notesGetData = async () => {
        try {
            const response = await DataService.getData({
                api: "rms/properties/notes/" + app_state.property_id + "/?fromDate=" + dateFormat(arrivalDate, "YYYY-MM-DD") + "&toDate=" + dateFormat(departureDate, "YYYY-MM-DD") + "&fillMissingDays=true&flat=true",
                request: { method: 'GET' }
            });
            if (response.status === "success") {
                app_state.notes = response.data;
                dispatch({
                    type: UPDATE_STATE,
                    payload: {
                        app_state: {
                            ...app_state,
                        }
                    }
                })
            }
            else {
                console.log("Note API status error")
            }
        }
        catch (error) {
            console.error('An error occurred', error);
        }
    }
    const avgImpactGetData = async () => {
        try {
            const response = await DataService.getData({
                api: "rms/properties/events/" + app_state.property_id + "/?fromDate=" + dateFormat(arrivalDate, "YYYY-MM-DD") + "&toDate=" + dateFormat(departureDate, "YYYY-MM-DD") + "&avgDemandImpact=true&isIgnored=false",
                request: { method: 'GET' }
            });
            if (response.status === "success") {
                app_state.avgImpactData = response.data;
                dispatch({
                    type: UPDATE_STATE,
                    payload: {
                        app_state: {
                            avgImpactData: response.data
                        }
                    }
                })
            }
            else {
                console.log("Events List API status error")
            }
        }
        catch (error) {
            console.error('An error occurred', error);
        }
    }
    const EventsListGetData = async () => {
        try {
            const response = await DataService.getData({
                api: "rms/properties/events/" + app_state.property_id + "/?fromDate=" + dateFormat(arrivalDate, "YYYY-MM-DD") + "&toDate=" + dateFormat(departureDate, "YYYY-MM-DD"),
                request: { method: 'GET' }
            });
            if (response.status === "success") {
                app_state.eventList = response.data;
                dispatch({
                    type: UPDATE_STATE,
                    payload: {
                        app_state: {
                            eventList: response.data
                        }
                    }
                })
            }
            else {
                console.log("Events List API status error")
            }
        }
        catch (error) {
            console.error('An error occurred', error);
        }
    }

    useEffect(() => {
        notesGetData();
        avgImpactGetData();
        EventsListGetData();

        //Stop Bellow code to run on first render
        if (checkFirstRender.current) {
            checkFirstRender.current = false;
            return;
        }
        updateFooterData(groupIQSettings);
    }, [arrivalDate, departureDate]);


    const navigate = useNavigate();
    function goBackToDashboard() {
        ancillaryRevTabData.current = null;
        roomBlockTabData.current = null;
        customRateTabData.current = null;
        wishRateTabData.current = null;

        otbRmType.current = null;
        setResponseFromAPI(null);

        localStorage.removeItem('isOpenDefault');
        localStorage.removeItem('isReload');
        localStorage.removeItem('isChanged');
        localStorage.removeItem('isGroupSettingsChanged');
        localStorage.removeItem('isGroupSettingsDashboard');

        dispatch({
            type: UPDATE_STATE,
            payload: {
                app_state: {
                    data_load: true,
                    kpi_load: true,
                },
                ui_state: {
                    active_settings_menu: "",
                    showspinner: true,
                }
            },
        });

        navigate("/");
    }

    const groupIcon = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#00415F" viewBox="0 0 256 256"><path d="M164.38,181.1a52,52,0,1,0-72.76,0,75.89,75.89,0,0,0-30,28.89,12,12,0,0,0,20.78,12,53,53,0,0,1,91.22,0,12,12,0,1,0,20.78-12A75.89,75.89,0,0,0,164.38,181.1ZM100,144a28,28,0,1,1,28,28A28,28,0,0,1,100,144Zm147.21,9.59a12,12,0,0,1-16.81-2.39c-8.33-11.09-19.85-19.59-29.33-21.64a12,12,0,0,1-1.82-22.91,20,20,0,1,0-24.78-28.3,12,12,0,1,1-21-11.6,44,44,0,1,1,73.28,48.35,92.18,92.18,0,0,1,22.85,21.69A12,12,0,0,1,247.21,153.59Zm-192.28-24c-9.48,2.05-21,10.55-29.33,21.65A12,12,0,0,1,6.41,136.79,92.37,92.37,0,0,1,29.26,115.1a44,44,0,1,1,73.28-48.35,12,12,0,1,1-21,11.6,20,20,0,1,0-24.78,28.3,12,12,0,0,1-1.82,22.91Z"></path></svg>
    const CustomDropdownIcon = (props) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#606060"
            viewBox="0 0 256 256"
            style={{ top: "10px", right: "10px" }}
            {...props}
        >
            <path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path>
        </svg>
    );
    const [category, setCategory] = useState("");
    const handleCategoryChange = (event) => {
        groupTypeError.current = event.target.value ? false : true;
        setCategory(event.target.value);
    };

    const [value, setValue] = React.useState(0);
    const [value2, setValue2] = React.useState(0);
    const [groupName, setGroupName] = React.useState("");
    const calendarRef = useRef(null);

    let obj = {
        "loading": false,
        "loaded": false,
        "error": false
    }
    const [compState, setCompState] = React.useState(obj);
    const [open, setOpen] = React.useState(false);
    const handleGroupName = (event) => {
        let grpNameValue = event.currentTarget.value;
        groupNameError.current = grpNameValue.trim() ? false : true;
        setGroupName(grpNameValue);
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChange2 = (event, newValue) => {
        if (newValue === 2) {
            window.analyze.track('groupIQ_custom_tab', {
                "previous_groupIQ_custom_tab": 'No',
                "current_groupIQ_custom_tab": 'Yes',
            }, { ...app.current_state }, { app_state, ui_state });
        }

        setValue2(newValue);
        totalNightsRef.current.innerText = topNumber.current[newValue].totalNights;
        roomsPerDayRef.current.innerText = topNumber.current[newValue].roomsPerDay;
        totalRevenueRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[newValue].totalRevenue);
        totalIncrementalRevenueRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[newValue].totalIncrementalRevenue);
        optimalAcceptableRateRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[newValue].optimalAcceptableRate);
        revenueExpectedRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[newValue].revenueExpected);
        revenueDisplacedRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[newValue].roomRevenueDisplaced);
    };
    //For mailer popover
    const handleClick = () => {
        setOpen((prev) => !prev);
    };
    const handleClickAway = () => {
        setOpen(false);
    };

    const [loading, setLoading] = useState(false);
    async function checkOTBData(selectedDates) {
        let start_date = selectedDates[0];
        let end_date = selectedDates.length === 1 ? selectedDates[0] : selectedDates[selectedDates.length - 1];
        try {
            setLoading(true);
            const responseOTBRmType = await getOtbRmType(start_date, end_date);
            if (responseOTBRmType) {
                const resData = {
                    otbRmType: responseOTBRmType,
                };
                return resData;
            }
        } catch (error) {
            return error;
        }
    }

    async function getOtbRmType(start_date, end_date) {
        try {
            let property_id = app_state.property_id;
            let sdYear = app_state.workspace_controls.sdYear;
            let asOfDate = as_of_date;
            let rangeFromDate = start_date; //sDate;//app_state.primary_stay_range.date_to;
            let rangeToDate = end_date;
            let rmTypeOtb = `rms/properties/otb-rt/${property_id}/?sdYear=${sdYear}&includeSdly=false&fromDate=${rangeFromDate}&toDate=${rangeToDate}&asOfDate=${asOfDate}`;
            const response = await fetchDataSimple({ api: rmTypeOtb, request: { method: 'GET' } });
            if (response.status === "success") {
                dataService.updateDataCache("GetRoomType", { data: response, loaded: true, loading: false, reqParams: null });
            }
            const data = await response.data;
            return data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        let { arrivalDate, departureDate } = dates;
        arrivalDate = moment(arrivalDate).format("YYYY-MM-DD");
        departureDate = moment(departureDate).format("YYYY-MM-DD");
        let setDates = [];
        for (var m = moment(arrivalDate); m.isBefore(departureDate); m.add(1, 'days')) {
            let date = moment(m).format("YYYY-MM-DD");
            setDates.push(date);
        }

        checkOTBData(setDates)
            .then((rs) => {
                otbRmType.current = rs.otbRmType;
                setLoading(false);
            })

    }, [arrivalDate, departureDate])

    /// getting Room details details
    let dates = { arrivalDate, departureDate };
    const { totalCapacity, selectedDates, finalPayload } = calculateRoomDetails(auth, app_state, dates);


    useEffect(() => {
        if (responseFromAPI.data !== undefined && responseFromAPI.params_called_with !== undefined) {
            const { overall } = responseFromAPI.data.primary;
            const { wish, walk } = overall;

            // Update output top data
            let totalNights = dateDiff(overall.departure_date, overall.arrival_date);
            let totalRooms = 0;
            responseFromAPI.params_called_with.dates.forEach(dateEntry => {
                let rooms = dateEntry.rooms.reduce((sum, room) => sum + room.rooms, 0);
                totalRooms = totalRooms + rooms
            })
            let roomsPerDay = Math.round(totalRooms / totalNights);

            let topNumberNew = deepCopy(topNumber.current);
            topNumberNew[0].totalNights = totalNights;
            topNumberNew[1].totalNights = totalNights;
            topNumberNew[2].totalNights = totalNights;

            topNumberNew[0].totalRooms = totalRooms;
            topNumberNew[1].totalRooms = totalRooms;
            topNumberNew[2].totalRooms = totalRooms;

            topNumberNew[0].roomsPerDay = roomsPerDay;
            topNumberNew[1].roomsPerDay = roomsPerDay;
            topNumberNew[2].roomsPerDay = roomsPerDay;

            topNumberNew[0].totalRevenue = Math.round(wish.total_revenue);
            topNumberNew[1].totalRevenue = Math.round(walk.total_revenue);
            topNumberNew[2].totalRevenue = Math.round(wish.total_revenue);

            topNumberNew[0].totalIncrementalRevenue = Math.round(wish.incremental_revenue);
            topNumberNew[1].totalIncrementalRevenue = Math.round(walk.incremental_revenue);
            topNumberNew[2].totalIncrementalRevenue = Math.round(wish.incremental_revenue);

            // Recommended Rate Box Value
            topNumberNew[0].optimalAcceptableRate = Math.round(wish.rate);
            topNumberNew[1].optimalAcceptableRate = Math.round(walk.rate);
            topNumberNew[2].optimalAcceptableRate = Math.round(wish.rate);

            topNumberNew[0].revenueExpected = Math.round(wish.room_revenue);
            topNumberNew[1].revenueExpected = Math.round(walk.room_revenue);
            topNumberNew[2].revenueExpected = Math.round(wish.room_revenue);

            topNumberNew[0].roomRevenueDisplaced = Math.round(overall.displaced_revenue);
            topNumberNew[1].roomRevenueDisplaced = Math.round(overall.displaced_revenue);
            topNumberNew[2].roomRevenueDisplaced = Math.round(overall.displaced_revenue);

            topNumber.current = deepCopy(topNumberNew);

            // Update output bottom data
            setProfitMarginText(Object.keys(responseFromAPI.params_called_with.profit_percents).map((key) => {
                const percent = (convertToPercent(responseFromAPI.params_called_with.profit_percents[key])); // convert to percentage format
                const label = keyToLabel(key); // format label
                return `${label}: ${percent}%`;
            }).join(', '));
            setCommissionText(convertToPercent(responseFromAPI.params_called_with.comission_percent) + "%");
            setComplimentaryRoomsText(responseFromAPI.params_called_with.comp_rooms.rooms + " ROH");
            setPerPaidRoomText(responseFromAPI.params_called_with.comp_rooms.per_block);
            let expiryDate = moment().add(6, 'days');
            addMoreInfoValue.current = "Quote Expiry: " + dateFormat(expiryDate, "DD MMM, YYYY");
        }
    }, [responseFromAPI]);

    /////   submit button functionality ////

    const [emails, setEmails] = useState([])

    const handleEmails = (newValue) => {
        // Only keep unique and valid emails in state
        const uniqueValidEmails = newValue.filter((email) => validateEmail(email.trim()));
        setEmails(uniqueValidEmails);
    };

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    const [emailCheckBox, setEmailCheckbox] = useState({
        wishRate: true,
        walkRate: true,
        customRate: true,
    });

    const handleRateChange = (rate) => {
        setEmailCheckbox((prevRates) => ({
            ...prevRates,
            [rate]: !prevRates[rate],
        }));
    };


    const [showAllContainers, setShowAllContainers] = useState(false);
    const [submitAnyway, setSubmitAnyway] = useState(false);

    const [alertText, setAlertText] = useState("");
    const showAlert = async () => {
        let alertContainer = document.getElementsByClassName("save-changes-alert");
        if (alertContainer.length > 0) {
            alertContainer[0].className = alertContainer[0].className.replace("display-none", "").trim();
            setTimeout(() => {
                alertContainer[0].className += " display-none";
            }, 3000);
        }
    }

    // Function for submit a quote
    const handleSubmit = () => {
        const totalRow = roomBlockTabData.current.dataSource[roomBlockTabData.current.dataSource.length - 1]
        const totalRequired = totalRow === undefined ? 0 : totalRow['total-required']
        groupTypeError.current = false
        groupNameError.current = false
      
        //  else if (!groupName.trim()) {
        //     setAlertText("Group Name is Required.");
        //     groupNameError.current = true
        //     showAlert();
        //     return;
        // } else if (!category.trim()) {
        //     setAlertText("Group Type is Required.");
        //     groupTypeError.current = true
        //     showAlert();
        //     return;
        // } 
        if (totalRequired === 0) {
            groupTypeError.current = false;
            setAlertText("Atleast One Room is Required.");
            showAlert();
            return;
        }

        let validationFailed = false;
        if (groupIQSettings && groupIQSettings.blackout_dates && groupIQSettings.blackout_dates.length > 0) {
            groupIQSettings.blackout_dates.forEach((item) => {
                const blackoutDateValidation = isDateInRange(item, arrivalDate, departureDate);
                if (blackoutDateValidation) {
                    validationFailed = true;
                    return;
                }
            })
        }
        if (validationFailed) {
            console.log("Validation failed, Selected stay dates includes blackout dates");
            setSubmitAnyway(true);
            return;
        }
        else {
            //setShowAllContainers(true);
            window.analyze.track('groupIQ_submit_quote', {
                "previous_groupIQ_submit_quote": 'No',
                "current_groupIQ_submit_quote": 'Yes',
            }, { ...app.current_state }, { app_state, ui_state });
            setIsSubmitting(true);
            submitQuoteAPI();
        }
        
    }

    // Function to submit a quote with blackout dates
    const handleSubmitAnyway = () => {
        setIsSubmittingAnyway(true);
        submitQuoteAPI();
    }

    // Function to cancel submit quote with blackout dates
    const cancelSubmitAnyway = () => {
        setSubmitAnyway(false);
    }

    // function for reset a quote 
    const handleReset = () => {
        if (isSaved) {
            //New quote
            ancillaryRevTabData.current = { ...initialTabTemplate };
            roomBlockTabData.current = { ...initialTabTemplate };
            customRateTabData.current = { ...initialTabTemplate };
            wishRateTabData.current = { ...initialTabTemplate };
            setIsSaved(false);
            setShowAllContainers(false);
            setValue(0);
            setValue2(0);
            setGroupName("");
            setCategory("");
        } else {
            // Reset
            customRateTabData.current = { ...initialTabTemplate };
            wishRateTabData.current = { ...initialTabTemplate };
            setShowAllContainers(false);
            setValue(0);
            setValue2(0);
        }
    }

    const [dateRangePickerVisiblity, setDateRangePickerVisiblity] = useState(false);
    const toggleDateRangePickerVisiblity = () => {
        calendarRef.current.focus();
        if (dateRangePickerVisiblity) {

            if (arrivalDateTemp !== arrivalDate || departureDateTemp !== departureDate) {
                setArrivalDate(moment(arrivalDateTemp).format('YYYY-MM-DD'));
                setDepartureDate(moment(departureDateTemp).format('YYYY-MM-DD'));
                setValue(0);
                ancillaryRevTabData.current = { ...initialTabTemplate };
                roomBlockTabData.current = { ...initialTabTemplate };
                customRateTabData.current = { ...initialTabTemplate };
                wishRateTabData.current = { ...initialTabTemplate };
            }
            setDateRangePickerVisiblity(false);

        }
        else {
            setDateRangePickerVisiblity(true);
        }
    };

    const preventTyping = (e) => {
        e.preventDefault();
        return false;
    }

    const [openSettingTabValue, setOpenSettingTabValue] = useState(0);

    function handleOpenSetting(event) {
        setOpenSetting(true);
        setOpenSettingTabValue(0);
    }
    function handleCloseSetting() {
        const isChanged = localStorage.getItem('isChanged');
        if (isChanged == 'true') {
            let shakeBtnDiv = document.getElementsByClassName("create-demand-action-btns");
            if (shakeBtnDiv.length > 0) {
                Array.from(shakeBtnDiv).forEach((btnDiv) => {
                    btnDiv.classList.add("bt-shake");
                });

                setTimeout(() => {
                    Array.from(shakeBtnDiv).forEach((btnDiv) => {
                        btnDiv.classList.remove("bt-shake");
                    });
                }, 2000);
            }
            return;
        }

        const isOpenDefault = localStorage.getItem('isOpenDefault');
        const isReload = localStorage.getItem('isReload');

        if (isOpenDefault == 'true') {
            setOpenDefaultSetupAlert(true);
        }
        else {
            setOpenDefaultSetupAlert(false);
            if (isReload == 'true') {
                localStorage.setItem("isReload", false);
                window.location.reload();
            }
        }

        setOpenSetting(false);
        
        // Fetch settings data and Update footer if settings is changed
        const isGroupSettingsChanged = localStorage.getItem("isGroupSettingsChanged");
        if (isGroupSettingsChanged == 'true') {
            localStorage.setItem("isGroupSettingsChanged", false)
            getGroupQouteSettings1().then((rs) => {
                const data = deepCopy(rs.data);
                dispatch({
                    type: UPDATE_STATE,
                    payload: {
                        app_state: {
                            groupIQSettings: data
                        }
                    }
                });
                setTimeout(() => {
                    settingsDisabledRef.current = false;
                    updateFooterData(data);
                }, 10);
            });
        }
    }

    const settingTabChange = (event, newValue) => {
        const isChanged = localStorage.getItem('isChanged');
        if (isChanged == 'true') {
            let shakeBtnDiv = document.getElementsByClassName("create-demand-action-btns");
            if (shakeBtnDiv.length > 0) {
                Array.from(shakeBtnDiv).forEach((btnDiv) => {
                    btnDiv.classList.add("bt-shake");
                });

                setTimeout(() => {
                    Array.from(shakeBtnDiv).forEach((btnDiv) => {
                        btnDiv.classList.remove("bt-shake");
                    });
                }, 2000);
            }
            return;
        }
        setOpenSettingTabValue(newValue);
    };

    const [showAddMoreInfo, setShowAddMoreInfo] = useState(false);
    const handleAddMoreInfo = () => {
        setShowAddMoreInfo(!showAddMoreInfo);
    }

    const handleAddMoreInputChange = useCallback((event) => {
        addMoreInfoValue.current = event.target.value;
    }, []);

    const collectAncillaryRevTabData = useCallback((data) => {
        ancillaryRevTabData.current = data;
    }, [])

    const collectRoomBlockTabData = useCallback((data) => {
        roomBlockTabData.current = data;
    }, [])

    const collectCustomRateTabData = useCallback((data) => {
        customRateTabData.current = data;
        updateCustomeRateTopNumber(data);
    }, [])

    const collectWishRateTabData = useCallback((data) => {
        wishRateTabData.current = data;
    }, [])


    const updateCustomeRateTopNumber = (data) => {
        const { columnGroupObjs, dataSource } = data;
        let totalRevenue = 0;
        let TotalRevenueExpected = 0;
        let totalIncrementalRevenue = 0;
        columnGroupObjs.forEach(item => {
            if (!["ancillaryRev", "totalRoomRev", "staydates"].includes(item.name)) {
                totalRevenue += Number(dataSource[dataSource.length - 1][`${item.name}-roomRev`]);
                TotalRevenueExpected += Number(dataSource[dataSource.length - 1][`${item.name}-roomRev`]);
                totalIncrementalRevenue += Number(dataSource[dataSource.length - 1][`${item.name}-incrementalRev`]);
            }
        })
        totalRevenue += Number(dataSource[dataSource.length - 1]['ancillaryRev-total']);

        topNumber.current[2].totalRevenue = totalRevenue;
        topNumber.current[2].totalIncrementalRevenue = totalIncrementalRevenue;
        topNumber.current[2].revenueExpected = TotalRevenueExpected;
        topNumber.current[2].optimalAcceptableRate = (TotalRevenueExpected / (topNumber.current[2].totalRooms )).toFixed(0);

        totalRevenueRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[2].totalRevenue);
        totalIncrementalRevenueRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[2].totalIncrementalRevenue);
        optimalAcceptableRateRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[2].optimalAcceptableRate);
        revenueExpectedRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[2].revenueExpected);
    }

    const getPrimaryData = (index) => {
        const { dataSource: roomBlockDataSource,
            columnGroupObjs: roomBlockColumnGroupObjs } = roomBlockTabData.current;
        let primaryOBJ = {};
        if (roomBlockDataSource.length && roomBlockColumnGroupObjs.length) {
            primaryOBJ.rooms = Number(roomBlockDataSource[index]['total-required']);
            primaryOBJ.room_type = roomBlockColumnGroupObjs.reduce((acc, item) => {
                if (!['runOfHouse', 'staydates', 'total'].includes(item.name)) {
                    acc[item.name] = Number(roomBlockDataSource[index][`${item.name}-required`]);
                }
                return acc;
            }, {});

        } else {
            primaryOBJ.rooms = 0;
            primaryOBJ.room_type = {};
        }
        return primaryOBJ;
    }

    const getAncillaryData = (index) => {

        const { groupIQSettings } = app_state;
        let gIQSDefault = groupIQSettings.hasOwnProperty('default_settings') ? groupIQSettings.default_settings : {};
        let gIQSSeasons = groupIQSettings.hasOwnProperty('seasons') ? groupIQSettings.seasons : [];
        let selectedSeasonsIndex = -1;

        if (gIQSSeasons.length) {
            selectedSeasonsIndex = gIQSSeasons.findIndex(season => {
                return moment(season.start_date).isSameOrBefore(arrivalDate) && moment(season.end_date).isSameOrAfter(arrivalDate)
            });
        }

        const { dataSource: ancillaryRevDataSource,
            columnGroupObjs: ancillaryRevColumnGroupObjs } = ancillaryRevTabData.current;

        let primaryOBJ = {};
        if (ancillaryRevDataSource.length && ancillaryRevColumnGroupObjs.length) {

            primaryOBJ = ancillaryRevColumnGroupObjs.reduce((acc, item) => {
                if (!['staydates', 'total'].includes(item.name)) {
                    acc[item.name] = Number(ancillaryRevDataSource[index][item.name]);
                }
                return acc;
            }, {});

        } else {

            if (selectedSeasonsIndex > -1 && gIQSSeasons[selectedSeasonsIndex].hasOwnProperty('profitMargins') && Object.keys(gIQSSeasons[selectedSeasonsIndex].profitMargins).length) {
                Object.keys(gIQSSeasons[selectedSeasonsIndex].profitMargins).forEach(key => {
                    primaryOBJ[key] = 0;
                })
            }
            else if (gIQSDefault.hasOwnProperty('profitMargins') && Object.keys(gIQSDefault.profitMargins).length) {
                Object.keys(gIQSDefault.profitMargins).forEach(key => {
                    primaryOBJ[key] = 0;
                })
            }
        }
        primaryOBJ['food_bev'] = primaryOBJ['food_beverage'];
        primaryOBJ['other'] = primaryOBJ['others'];
        delete primaryOBJ['food_beverage'];
        delete primaryOBJ['others'];
        return primaryOBJ;
    }

    const getDatesData = () => {
        let date = moment(arrivalDate).format("YYYY-MM-DD");
        let numDays = dateDiff(departureDate, arrivalDate);
        let datesDataArr = [];

        for (let index = 0; index < numDays; index++) {
            let dataPoint = {}
            dataPoint = {
                date: date,
                primary: getPrimaryData(index),
                ancillary: getAncillaryData(index),
            }
            datesDataArr.push(dataPoint);
            date = moment(date).add(1, 'days').format("YYYY-MM-DD");
        }
        return datesDataArr
    }

    const getOverallRequest = () => {
        const { footerField: ancillaryFooterField } = ancillaryRevTabData.current;
        const { footerField: roomBlockFooterField } = roomBlockTabData.current;

        const { groupIQSettings } = app_state;
        let gIQSDefault = groupIQSettings.hasOwnProperty('default_settings') ? groupIQSettings.default_settings : {};
        let gIQSSeasons = groupIQSettings.hasOwnProperty('seasons') ? groupIQSettings.seasons : [];
        let selectedSeasonsIndex = -1;

        if (gIQSSeasons.length) {
            selectedSeasonsIndex = gIQSSeasons.findIndex(season => {
                return moment(season.start_date).isSameOrBefore(arrivalDate) && moment(season.end_date).isSameOrAfter(arrivalDate)
            });
        }

        let overallObj = {};

        if (roomBlockFooterField && Object.keys(roomBlockFooterField).length > 0) {
            overallObj.comp_rooms = {
                comp_room_amt: Number(roomBlockFooterField.complimentaryRooms),
                comp_room_per_rooms: Number(roomBlockFooterField.perPadeRooms),
            };
            overallObj.comission_percent = Number(roomBlockFooterField.commission);
        } else {
            overallObj.comp_rooms = {
                comp_room_amt: Number(revenueModifier.complimentaryRooms),
                comp_room_per_rooms: Number(revenueModifier.perPadeRooms),
            };
            overallObj.comission_percent = Number(revenueModifier.commission);
        }

        let profitPercentsObj = {};
        if (ancillaryFooterField && Object.keys(ancillaryFooterField).length > 0) {
            profitPercentsObj = deepCopy(ancillaryFooterField)
        }
        else {
            Object.keys(profitMargins).forEach(key => {
                profitPercentsObj[key] = profitMargins[key];
            })
        }
        profitPercentsObj['food_bev'] = profitPercentsObj['food_beverage'];
        profitPercentsObj['other'] = profitPercentsObj['others'];
        delete profitPercentsObj['food_beverage'];
        delete profitPercentsObj['others'];
        Object.keys(profitPercentsObj).forEach(key => {
            profitPercentsObj[key] = Number(profitPercentsObj[key]);
        })
        overallObj.profit_percents = deepCopy(profitPercentsObj);

        return overallObj;
    }

    // Submit quote POST API call
    const submitQuoteAPI = async () => {
        let datesData = getDatesData();
        let overallRequest = getOverallRequest();

        const payload = {
            as_of_date: as_of_date,
            group_name: groupName,
            type: category,
            dates: datesData,
            overall_request: overallRequest,
        }
        console.log("payload", payload);

        try {
            const response = await DataService.update({
                api: "rms/properties/group-quote-v2/" + app_state.property_id + "/",
                request: payload
            });

            if (response.status === "success") {
                console.log("Group quote created successfully", response);
                customRateTabData.current = { ...initialTabTemplate };
                wishRateTabData.current = { ...initialTabTemplate };

                setResponseFromAPI(response);
                setIsSubmitting(false);
                setIsSubmittingAnyway(false);
                setSubmitAnyway(false);
                setShowAllContainers(true);

                setGroupName(response.params_called_with.group_name);
                setCategory(response.params_called_with.type);

                totalNightsRef.current.innerText = topNumber.current[0].totalNights;
                roomsPerDayRef.current.innerText = topNumber.current[0].roomsPerDay;
                totalRevenueRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[0].totalRevenue);
                totalIncrementalRevenueRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[0].totalIncrementalRevenue);
                optimalAcceptableRateRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[0].optimalAcceptableRate);
                revenueExpectedRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[0].revenueExpected);
                revenueDisplacedRef.current.innerText = formatCurrency(currency_symbol, topNumber.current[0].roomRevenueDisplaced);
            }
            else {
                console.log("Group quote not created")
                setIsSubmitting(false);
                setIsSubmittingAnyway(false);
                setSubmitAnyway(false);

                setAlertText(response.message);
                showAlert();
            }
        }
        catch (err) {
            console.error('An error occurred', err);
            setIsSubmitting(false);
            setIsSubmittingAnyway(false);
            setSubmitAnyway(false);
        }
        //setShowAllContainers(true);
    }

    // Function to Save a quote and additional note
    const payloadCustomTabCustom = (index) => {
        const { dataSource, columnObjs, columnGroupObjs } = customRateTabData.current.dataSource.length > 0 ? customRateTabData.current : wishRateTabData.current;
        const { dates } = responseFromAPI.data.primary;
        let customArr = [];
        if (dataSource.length && columnGroupObjs.length) {
            columnGroupObjs.forEach(group => {
                if (!['ancillaryRev', 'staydates', 'totalRoomRev'].includes(group.name)) {
                    let customObj = {}
                    customObj['room_type'] = group.name;
                    customObj['rooms'] = Number(dataSource[index][`${group.name}-rooms`]);
                    customObj['rate'] = Number(dataSource[index][`${group.name}-rate`]);
                    customObj['discount'] = Number(Number(dataSource[index][`${group.name}-discount`]).toFixed(3));
                    customObj['bar_sell_rate'] = Number(dates[index].wish.find(item => item.room_type === group.name).bar_sell_rate);
                    customObj['revenue'] = Number(dataSource[index][`${group.name}-roomRev`]);
                    customObj['displaced_revenue'] = Number(dataSource[index][`${group.name}-displacedRev`]);
                    customObj['incremental_revenue'] = Number(dataSource[index][`${group.name}-incrementalRev`]);
                    customArr.push(customObj);
                }
            })
        }
        return customArr;
    }
    const payloadCustomTabCustomRevenue = (index) => {
        const { dataSource, columnObjs, columnGroupObjs } = customRateTabData.current.dataSource.length > 0 ? customRateTabData.current : wishRateTabData.current;
        let customRevenue = 0;
        if (dataSource.length && columnGroupObjs.length) {
            customRevenue = Number(dataSource[index]['totalRoomRev-revenue']);
        }
        return customRevenue;
    }

    const payloadCustomTabDates = () => {
        let date = moment(arrivalDate).format("YYYY-MM-DD");
        let numDays = dateDiff(departureDate, arrivalDate);
        let customTabDatesData = [];
        for (let index = 0; index < numDays; index++) {
            let dataPoint = {}
            dataPoint = {
                date: date,
                custom_revenue: payloadCustomTabCustomRevenue(index),
                custom: payloadCustomTabCustom(index),
            }
            customTabDatesData.push(dataPoint);
            date = moment(date).add(1, 'days').format("YYYY-MM-DD");
        }
        return customTabDatesData;
    }
    const handleSaveQuote = async () => {
        if (groupName.trim() === "" || category.trim() === "") {
            if(groupName.trim() === "") {
                setGroupName("");
            }
            if(category.trim() === "") {
                setCategory("");
            }
            setGroupNameTypePopupOpen(true);
            return;
        }
        const payload = {
            method: 'PUT',
            group_quote_id: responseFromAPI.group_quote_id,
            proposal: true,
            group_name: groupName,
            type: category,
            additional_notes: addMoreInfoValue.current,
            dates: payloadCustomTabDates()
        }

        setIsSaving(true);

        try {
            const response = await DataService.update({
                api: "rms/properties/group-quote-v2/" + app_state.property_id + "/",
                request: payload
            });
            if (response.status === "success") {
                console.log("Group quote saved successfully", response);
                ancillaryRevTabData.current = { ...initialTabTemplate };
                roomBlockTabData.current = { ...initialTabTemplate };
                //customRateTabData.current = { ...initialTabTemplate };
                setIsSaving(false);
                setIsSaved(true);
                window.analyze.track('groupIQ_save_quote', {
                    "previous_groupIQ_save_quote": 'No',
                    "current_groupIQ_save_quote": 'Yes',
                }, { ...app.current_state }, { app_state, ui_state });

            }
            else {
                console.log("Group quote not saved")
                setIsSaving(false);
            }
        }
        catch (err) {
            console.error('An error occurred', err);
            setIsSaving(false);
        }
    }

    // Function to download report
    const handleDownloadReport2 = async () => {
        const payload = {
            group_quote_id: responseFromAPI.group_quote_id
        }
        console.log("payload", payload)
        try {
            const response = await DataService.update({
                api: "rms/properties/download-group-quote-v2/" + app_state.property_id + "/",
                request: payload
            });
            if (response.status === "success") {
                console.log("Report downloaded successfully", response);
                // Create a download link and trigger it programmatically
                const link = document.createElement('a');
                link.href = response.exportUrl;
                link.download = response.file; // filename coming from response
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                toast.dismiss();
                toast.success("Report downloaded successfully", {
                    position: "bottom-right"
                });
            }
            else {
                console.log("Report not downloaded")
                toast.dismiss();
                toast.error("Report couldn't be download. Please try again.", {
                    position: "bottom-right"
                });
            }
        }
        catch (err) {
            console.error('An error occurred', err);
            toast.dismiss();
            toast.error("Report couldn't be download. Please try again.", {
                position: "bottom-right"
            });
        }
    }

    // Function to email report
    const handleEmailReport2 = async () => {
        const payload = {
            group_quote_id: responseFromAPI.group_quote_id,
            emails: emails,
            wish_rate_enabled: emailCheckBox.wishRate,
            walk_rate_enabled: emailCheckBox.walkRate,
            custom_rate_enabled: emailCheckBox.customRate
        }
        console.log("payload", payload)

        setOpen(false);

        try {
            const response = await DataService.update({
                api: "rms/properties/download-group-quote-v2/" + app_state.property_id + "/",
                request: payload
            });
            if (response.status === "success") {
                console.log("Email sent successfully", response);
                setEmails([]);
                toast.dismiss();
                toast.success("Email sent to the entered addresses.", {
                    position: "bottom-right"
                });
            }
            else {
                console.log("Email not sent");
                toast.dismiss();
                toast.error("Email couldn't be sent. Please try again.", {
                    position: "bottom-right"
                });
            }
        }
        catch (err) {
            console.error('An error occurred', err);
            toast.dismiss();
            toast.error("Email couldn't be sent. Please try again.", {
                position: "bottom-right"
            });
        }
    }

    useEffect(() => {
        if (addMoreInfoRef.current) {
            // Append a new line to the current value
            addMoreInfoRef.current.value += "\n";

            // Move the cursor to the end of the text (now at the beginning of the new line)
            const valueLength = addMoreInfoRef.current.value.length;
            addMoreInfoRef.current.setSelectionRange(valueLength, valueLength);
            addMoreInfoRef.current.focus();
        }
    }, [showAddMoreInfo]);



    return (
        <AtuoLogoutTimer timeout={30} graceTime={5}>
            <div>

                <Header />

                <Box sx={{ pt: "60px", height: "100%" }}>
                    <Box className='top-axn-bar-1-groups'>
                        <div className="col1">
                            <Button
                                size="medium"
                                variant="contained"
                                className='back-to-dash-btn'
                                onClick={goBackToDashboard}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16.001" height="16.001" viewBox="0 0 16.001 16.001">
                                    <g id="Group_2234" data-name="Group 2234" transform="translate(24154 19449)">
                                        <path id="Path_3278" data-name="Path 3278" d="M.889,0h8.3a.889.889,0,0,1,.889.889V9.482a.889.889,0,0,1-.889.889H.889A.889.889,0,0,1,0,9.482V.889A.889.889,0,0,1,.889,0Z" transform="translate(-24154 -19449)" fill="#606060" />
                                        <g id="Path_3279" data-name="Path 3279" transform="translate(-24142.74 -19449)" fill="#333">
                                            <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                            <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                        </g>
                                        <g id="Path_3280" data-name="Path 3280" transform="translate(-24142.74 -19443.371)" fill="#333">
                                            <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                            <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                        </g>
                                        <g id="Path_3283" data-name="Path 3283" transform="translate(-24142.74 -19437.74)" fill="#333">
                                            <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                            <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                        </g>
                                        <g id="Path_3281" data-name="Path 3281" transform="translate(-24154 -19437.74)" fill="#333">
                                            <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                            <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                        </g>
                                        <g id="Path_3282" data-name="Path 3282" transform="translate(-24148.369 -19437.74)" fill="#333">
                                            <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                                            <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                                        </g>
                                    </g>
                                </svg>
                                <span className='back-to-dash-txt'>Back to Dashboard</span>
                            </Button>
                        </div>
                        <div className="col2">
                            <Box className="event-page-title">
                                {groupIcon}
                                <Badge className='badgeBeta onText' badgeContent={'BETA'} color="error">
                                    Group IQ
                                </Badge>
                            </Box>
                        </div>
                        <div className="col3">
                            {showAllContainers
                                ?
                                <Box className="action-button output" sx={{ display: "flex", alignItems: "center", justifyContent: "end", gap: "12px" }}>
                                    <Tooltip title={isSaved ? "Download Report" : "Save to Download Report"} arrow >
                                        {isSaved ?
                                            <div className='card-svg' >
                                                <svg onClick={handleDownloadReport2} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#606060" viewBox="0 0 256 256"><path d="M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,132.69V40a8,8,0,0,0-16,0v92.69L93.66,106.34a8,8,0,0,0-11.32,11.32Z"></path></svg>
                                            </div>
                                            :
                                            <div className='card-svg' style={{ cursor: "default", opacity: 0.3 }} >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#606060" viewBox="0 0 256 256"><path d="M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,132.69V40a8,8,0,0,0-16,0v92.69L93.66,106.34a8,8,0,0,0-11.32,11.32Z"></path></svg>
                                            </div>
                                        }
                                    </Tooltip>

                                    <ClickAwayListener onClickAway={handleClickAway}>

                                        <Box zIndex={1}>
                                            <Tooltip title={!open ? isSaved ? "Email Report" : "Save to Email Report" : ""} arrow >
                                                {isSaved ?
                                                    <div className='card-svg' style={open ? { background: "#EBEBEB" } : {}}>
                                                        <svg onClick={handleClick} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#606060" viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"></path></svg>
                                                    </div>
                                                    :
                                                    <div className='card-svg' style={{ cursor: "default", opacity: 0.3 }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#606060" viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"></path></svg>
                                                    </div>
                                                }
                                            </Tooltip>
                                            {open ? (
                                                <div className='sent-email'>
                                                    <svg style={{ position: "absolute", top: "-14px", right: "8px" }} xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#fff" viewBox="0 0 256 256"><path d="M215.39,163.06A8,8,0,0,1,208,168H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,215.39,163.06Z"></path></svg>
                                                    <div className='message-text'>
                                                        <Autocomplete
                                                            multiple
                                                            freeSolo
                                                            options={[]}
                                                            disableClearable
                                                            value={emails}  // Bind the emails state to the Autocomplete value
                                                            onChange={(event, newValue) => handleEmails(newValue)}
                                                            renderTags={(value, getTagProps) =>
                                                                value.map((option, index) => {
                                                                    const isValid = validateEmail(option);
                                                                    return (
                                                                        <Chip
                                                                            variant="outlined"
                                                                            label={option}
                                                                            {...getTagProps({ index })}
                                                                            style={{
                                                                                borderColor: isValid ? undefined : 'red',
                                                                            }}
                                                                        />
                                                                    );
                                                                })
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    autoFocus
                                                                    className='email-sent-textarea'
                                                                    fullWidth
                                                                    placeholder="abc@domain.com"
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        endAdornment: (
                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                {params.InputProps.endAdornment}
                                                                                <svg
                                                                                    style={emails.length > 0 ? { cursor: "pointer" } : { pointerEvents: "none", opacity: "0.4" }}
                                                                                    onClick={handleEmailReport2}
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="16"
                                                                                    height="16"
                                                                                    fill="#00415F"
                                                                                    viewBox="0 0 256 256"
                                                                                >
                                                                                    <path d="M227.32,28.68a16,16,0,0,0-15.66-4.08l-.15,0L19.57,82.84a16,16,0,0,0-2.42,29.84l85.62,40.55,40.55,85.62A15.86,15.86,0,0,0,157.74,248q.69,0,1.38-.06a15.88,15.88,0,0,0,14-11.51l58.2-191.94c0-.05,0-.1,0-.15A16,16,0,0,0,227.32,28.68ZM157.83,231.85l-.05.14L118.42,148.9l47.24-47.25a8,8,0,0,0-11.31-11.31L107.1,137.58,24,98.22l.14,0L216,40Z"></path>
                                                                                </svg>
                                                                            </div>
                                                                        ),
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                    <div className="rate-choice" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                            <Checkbox
                                                                className="checkbox"
                                                                checked={emailCheckBox.wishRate}
                                                                onClick={() => handleRateChange('wishRate')}

                                                            ></Checkbox>
                                                            Wish Rate
                                                        </div>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                            <Checkbox
                                                                className="checkbox"
                                                                checked={emailCheckBox.walkRate}
                                                                onClick={() => handleRateChange('walkRate')}
                                                            ></Checkbox>
                                                            Walk Rate
                                                        </div>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                            <Checkbox
                                                                className="checkbox"
                                                                checked={emailCheckBox.customRate}
                                                                onClick={(event) => handleRateChange('customRate')}
                                                            ></Checkbox>
                                                            Custom Rate
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </Box>

                                    </ClickAwayListener>

                                    {isSaved ?
                                        <Button
                                            //disabled={!isChangeRequest}
                                            className="navigate-cancel-button btn-active saved"
                                            size="small"
                                        >
                                            Saved
                                        </Button>
                                        :
                                        isSaving ?
                                            <Button
                                                disabled
                                                variant="outlined"
                                                size="small"
                                                className="navigate-cancel-button btn-active"
                                                sx={{ minWidth: "auto", lineHeight: "unset", gap: 1, pointerEvents: "none", width: "71.58px", height: "30.2px" }}
                                            >
                                                <CircularProgress color="inherit" size={16} />
                                            </Button>
                                            :
                                            <Button
                                                //disabled={!isChangeRequest}
                                                onClick={handleSaveQuote}
                                                variant="outlined"
                                                className="navigate-cancel-button btn-active"
                                                size="small"
                                                sx={{ minWidth: "auto", lineHeight: "unset" }}
                                                style={isSaving ? { pointerEvents: "none" } : {}}
                                            >
                                                Save
                                            </Button>
                                    }
                                    <Button
                                        disabled={isSaving}
                                        onClick={handleReset}
                                        variant="outlined"
                                        size="small"
                                        className="navigate-save-button btn-active"
                                        sx={{ minWidth: "auto", lineHeight: "unset" }}
                                    >
                                        {isSaved ? "New Quote" : "Reset"}
                                    </Button>
                                </Box>
                                :
                                <Box className="action-button">
                                    <Tooltip title="Settings" arrow >
                                        <div className="settings-icon" style={settingsDisabledRef.current ? { opacity: "0.4", pointerEvents: "none" } : {}}>
                                            <svg onClick={(event) => settingsDisabledRef.current ? null : handleOpenSetting(event)} xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#606060" viewBox="0 0 256 256"><path d="M128,76a52,52,0,1,0,52,52A52.06,52.06,0,0,0,128,76Zm0,80a28,28,0,1,1,28-28A28,28,0,0,1,128,156Zm113.86-49.57A12,12,0,0,0,236,98.34L208.21,82.49l-.11-31.31a12,12,0,0,0-4.25-9.12,116,116,0,0,0-38-21.41,12,12,0,0,0-9.68.89L128,37.27,99.83,21.53a12,12,0,0,0-9.7-.9,116.06,116.06,0,0,0-38,21.47,12,12,0,0,0-4.24,9.1l-.14,31.34L20,98.35a12,12,0,0,0-5.85,8.11,110.7,110.7,0,0,0,0,43.11A12,12,0,0,0,20,157.66l27.82,15.85.11,31.31a12,12,0,0,0,4.25,9.12,116,116,0,0,0,38,21.41,12,12,0,0,0,9.68-.89L128,218.73l28.14,15.74a12,12,0,0,0,9.7.9,116.06,116.06,0,0,0,38-21.47,12,12,0,0,0,4.24-9.1l.14-31.34,27.81-15.81a12,12,0,0,0,5.85-8.11A110.7,110.7,0,0,0,241.86,106.43Zm-22.63,33.18-26.88,15.28a11.94,11.94,0,0,0-4.55,4.59c-.54,1-1.11,1.93-1.7,2.88a12,12,0,0,0-1.83,6.31L184.13,199a91.83,91.83,0,0,1-21.07,11.87l-27.15-15.19a12,12,0,0,0-5.86-1.53h-.29c-1.14,0-2.3,0-3.44,0a12.08,12.08,0,0,0-6.14,1.51L93,210.82A92.27,92.27,0,0,1,71.88,199l-.11-30.24a12,12,0,0,0-1.83-6.32c-.58-.94-1.16-1.91-1.7-2.88A11.92,11.92,0,0,0,63.7,155L36.8,139.63a86.53,86.53,0,0,1,0-23.24l26.88-15.28a12,12,0,0,0,4.55-4.58c.54-1,1.11-1.94,1.7-2.89a12,12,0,0,0,1.83-6.31L71.87,57A91.83,91.83,0,0,1,92.94,45.17l27.15,15.19a11.92,11.92,0,0,0,6.15,1.52c1.14,0,2.3,0,3.44,0a12.08,12.08,0,0,0,6.14-1.51L163,45.18A92.27,92.27,0,0,1,184.12,57l.11,30.24a12,12,0,0,0,1.83,6.32c.58.94,1.16,1.91,1.7,2.88A11.92,11.92,0,0,0,192.3,101l26.9,15.33A86.53,86.53,0,0,1,219.23,139.61Z"></path></svg>
                                        </div>
                                    </Tooltip>
                                </Box>
                            }
                        </div>
                    </Box>

                    {showAllContainers
                        ?
                        <Box className="group-home-page-container">

                            <Box className="group-iq-top-bar-output">
                                <Box className='left-part'>
                                    <Box className="group-details">
                                        <Box>
                                            <div className="label">Name</div>
                                            <div className="data">{groupName!=="" ? groupName : "-"}</div>
                                        </Box>
                                        <Box>
                                            <div className="label">Type</div>
                                            <div className="data">{category!=="" ? category : "-"}</div>
                                        </Box>
                                        <Box>
                                            <div className="label">Check-In & Check-Out Date</div>
                                            <div className="data">{dateFormat(arrivalDate, "ddd, MMM DD YYYY") + " - " + dateFormat(departureDate, "ddd, MMM DD YYYY")}</div>
                                        </Box>
                                    </Box>

                                    <Box container direction="row" justifyContent="space-between" alignItems="center" className='facts'>
                                        <Box item className="total-counts">
                                            <div className='subheading'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M240,96a8,8,0,0,1-8,8H216v16a8,8,0,0,1-16,0V104H184a8,8,0,0,1,0-16h16V72a8,8,0,0,1,16,0V88h16A8,8,0,0,1,240,96ZM144,56h8v8a8,8,0,0,0,16,0V56h8a8,8,0,0,0,0-16h-8V32a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16Zm72.77,97a8,8,0,0,1,1.43,8A96,96,0,1,1,95.07,37.8a8,8,0,0,1,10.6,9.06A88.07,88.07,0,0,0,209.14,150.33,8,8,0,0,1,216.77,153Zm-19.39,14.88c-1.79.09-3.59.14-5.38.14A104.11,104.11,0,0,1,88,64c0-1.79,0-3.59.14-5.38A80,80,0,1,0,197.38,167.86Z"></path></svg>
                                                <div>Total Nights</div>
                                            </div>
                                            <div className='heading font-light' ref={totalNightsRef}></div>
                                        </Box>
                                        <Box item className="total-counts">
                                            <div className='subheading'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM192,40V216H176V40ZM64,40h96V216H64Zm80,92a12,12,0,1,1-12-12A12,12,0,0,1,144,132Z"></path></svg>
                                                <div>Rooms/Day</div>
                                            </div>
                                            <div className='heading font-light' ref={roomsPerDayRef}></div>
                                        </Box>
                                        <Box item className="total-counts">
                                            <div className='subheading'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,152ZM240,56H16a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H240a8,8,0,0,0,8-8V64A8,8,0,0,0,240,56ZM193.65,184H62.35A56.78,56.78,0,0,0,24,145.65v-35.3A56.78,56.78,0,0,0,62.35,72h131.3A56.78,56.78,0,0,0,232,110.35v35.3A56.78,56.78,0,0,0,193.65,184ZM232,93.37A40.81,40.81,0,0,1,210.63,72H232ZM45.37,72A40.81,40.81,0,0,1,24,93.37V72ZM24,162.63A40.81,40.81,0,0,1,45.37,184H24ZM210.63,184A40.81,40.81,0,0,1,232,162.63V184Z"></path></svg>
                                                <div>Total Revenue</div>
                                            </div>
                                            <div className='heading font-light' ref={totalRevenueRef}></div>
                                        </Box>
                                        <Box item className="total-counts">
                                            <div className='subheading'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V156.69l50.34-50.35a8,8,0,0,1,11.32,0L128,132.69,180.69,80H160a8,8,0,0,1,0-16h40a8,8,0,0,1,8,8v40a8,8,0,0,1-16,0V91.31l-58.34,58.35a8,8,0,0,1-11.32,0L96,123.31l-56,56V200H224A8,8,0,0,1,232,208Z"></path></svg>
                                                <div>Incremental Revenue</div>
                                            </div>
                                            <div className='heading font-light' ref={totalIncrementalRevenueRef}></div>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box item className='right-part'>
                                    <div className='recommended-rate'>
                                        <div className='heading'>
                                            <div>
                                                <div>Recommended Rate</div>
                                            </div>
                                        </div>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Box className='acceptable'>
                                                <div className='rev-txt'>Optimal Acceptable Rate</div>
                                                <div className='acceptable-rate' ref={optimalAcceptableRateRef}></div>
                                            </Box>

                                            <div>
                                                <svg width="43" height="110" viewBox="0 0 43 159" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0.0264893 79.1529C1.1021 78.8843 2.1626 78.5586 3.20349 78.177C5.1988 77.4212 7.13549 76.5187 8.99756 75.477C10.6929 74.4191 12.1039 72.9628 13.1077 71.2348C14.1114 69.5069 14.6776 67.5597 14.7566 65.563C15.1566 60.8709 15.2405 56.1439 15.2865 51.4309C15.3755 42.3079 15.2866 33.1829 15.3866 24.0599C15.3977 20.3801 15.9709 16.7236 17.0865 13.2169C17.8396 10.6934 19.2077 8.39635 21.068 6.53222C22.9283 4.66809 25.2225 3.29523 27.7445 2.53695C32.4904 1.11718 37.4253 0.430252 42.3785 0.499932C42.4974 0.501723 42.6144 0.529526 42.7213 0.581353C42.8283 0.633181 42.9225 0.707794 42.9976 0.799951C41.7396 1.04595 40.4735 1.25995 39.2245 1.54595C35.4977 2.14244 32.0741 3.95813 29.4896 6.70867C26.9052 9.45922 25.306 12.9893 24.9425 16.7459C24.5373 19.2877 24.3157 21.8553 24.2795 24.4289C24.1985 35.6969 24.2565 46.968 24.1975 58.236C24.249 61.5992 23.7467 64.9479 22.7106 68.148C22.0781 70.0658 21.0474 71.8282 19.6859 73.3197C18.3244 74.8111 16.6629 75.9978 14.8105 76.802C12.9565 77.65 10.9735 78.2179 9.04749 78.9079C8.78349 79.0019 8.5126 79.0749 7.9856 79.2389C8.22456 79.3667 8.46986 79.4821 8.72058 79.5849C10.5026 80.1679 12.3266 80.646 14.0646 81.341C16.5364 82.2565 18.7176 83.8177 20.3813 85.8621C22.0451 87.9066 23.1305 90.3597 23.5245 92.966C24.1124 96.568 24.3552 100.218 24.2495 103.866C24.2545 113.919 24.2375 123.972 24.2595 134.025C24.2012 137.558 24.5648 141.085 25.3425 144.531C26.8855 150.839 30.9086 154.783 36.9976 156.7C38.7836 157.262 40.6475 157.573 42.4745 158C42.6747 158.039 42.8544 158.148 42.9806 158.308C42.8145 158.404 42.632 158.468 42.4425 158.498C37.1765 158.251 31.9275 157.907 26.9355 155.957C24.4419 155.028 22.211 153.508 20.4343 151.527C18.6577 149.545 17.3885 147.163 16.7356 144.583C15.6768 140.578 15.1955 136.443 15.3065 132.302C15.3132 124.394 15.3102 116.486 15.2975 108.579C15.2865 104.612 15.2976 100.641 15.1276 96.6789C15.0316 94.6292 14.7352 92.5939 14.2426 90.602C13.7725 88.6342 12.8359 86.8084 11.5117 85.2789C10.1875 83.7493 8.51469 82.5609 6.63452 81.8139C4.71252 80.9669 2.68156 80.3699 0.700562 79.6579C0.465562 79.5729 0.236488 79.4729 0.000488281 79.3809L0.0264893 79.1529Z" fill="#EBEBEB" />
                                                </svg>
                                            </div>

                                            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "24px" }} className='rate-facts'>
                                                <Box className="rev-exp">
                                                    <div className='rev-txt'>Total Revenue Expected</div>
                                                    <div className='subheading' ref={revenueExpectedRef}></div>
                                                </Box>
                                                <Box className="rev-displayed">
                                                    <div className='rev-txt'>Total Revenue Displaced</div>
                                                    <div className='subheading' ref={revenueDisplacedRef}></div>
                                                </Box>
                                            </Box>
                                        </Box>

                                    </div>
                                </Box>
                            </Box>

                            <Box className={`tabular-data ${showAllContainers ? 'tabular-data-view-only' : ''}`}>
                                <Box mb={1.5} mt={showAllContainers && !compState.error ? 0 : 1.5}>
                                    <Tabs value={value2} onChange={handleChange2} className="tabs-wrap" aria-label="Wish Rate, Walk Rate, Custom Rate tabs">
                                        <Tab className='group-pricing-tabs' label="Wish Rate" {...a11yProps(0)} />
                                        <Tab className='group-pricing-tabs' label="Walk Rate" {...a11yProps(1)} />
                                        <Tab className='group-pricing-tabs' label="Custom Rate" {...a11yProps(2)} />
                                    </Tabs>
                                </Box>
                                <TabPanel className="tab-content wish-rate" value={value2} index={0}>
                                    <div className='tab-content-root'>
                                        <WishRate
                                            Smart={Smart}
                                            showAddMoreInfo={showAddMoreInfo}
                                            responseFromAPI={responseFromAPI}
                                            collectTabData={collectWishRateTabData}
                                            tabData={wishRateTabData}
                                        />
                                    </div>
                                </TabPanel>
                                <TabPanel className="tab-content wish-rate" value={value2} index={1}>
                                    <div className='tab-content-root'>
                                        <WalkRate
                                            Smart={Smart}
                                            showAddMoreInfo={showAddMoreInfo}
                                            responseFromAPI={responseFromAPI}
                                        />
                                    </div>
                                </TabPanel>
                                <TabPanel className="tab-content wish-rate" value={value2} index={2}>
                                    <div className='tab-content-root'>
                                        <CustomRate
                                            Smart={Smart}
                                            showAddMoreInfo={showAddMoreInfo}
                                            responseFromAPI={responseFromAPI}
                                            collectTabData={collectCustomRateTabData}
                                            tabData={customRateTabData}
                                            isSaved={isSaved}
                                        />
                                    </div>
                                </TabPanel>
                            </Box>

                            <Box className="group-iq-bottom-bar-output">
                                <div className="info-details-section">
                                    <div className="left-bottom-data">
                                        <div className="left-bottom-data-medium">
                                            Other Detail
                                        </div>
                                        <div className="left-bottom-data-regular">
                                            <span>Profit Margin: </span>{profitMarginText}
                                        </div>
                                        <div className="left-bottom-data-regular">
                                            <span>Complimentary Rooms:</span> {complimentaryRoomsText}, <span>Per Paid Rooms:</span> {perPaidRoomText}, <span>Commission:</span> {commissionText}
                                        </div>
                                    </div>
                                    <div className="right-bottom-data">
                                        <div className="add-information-btn" onClick={handleAddMoreInfo}>{showAddMoreInfo ? "Hide" : "+ Add More Information"}</div>
                                    </div>
                                </div>

                                {!showAddMoreInfo ? null :
                                    <div>
                                        <div className="divider-bottom"></div>
                                        <div className="add-info-section">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000000" viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z"></path></svg>
                                            <textarea
                                                ref={addMoreInfoRef}
                                                className="add-info-input"
                                                defaultValue={addMoreInfoValue.current}
                                                onChange={handleAddMoreInputChange}
                                                autoFocus
                                            ></textarea>
                                        </div>
                                    </div>
                                }
                            </Box>


                        </Box>
                        :
                        <Box className="group-home-page-container">

                            <Box className="group-iq-top-bar">
                                <Box item>
                                    <div className='top-bar-item first'>
                                        <label>Name</label>
                                        <TextField
                                            tabIndex={1}
                                            className='text-field group-name'
                                            defaultValue={groupName}
                                            fullWidth size='small'
                                            onBlur={handleGroupName}
                                            placeholder='Group Name'
                                            autoFocus
                                            //error={!!groupNameError.current}
                                        />
                                    </div>
                                </Box>
                                <Box item>
                                    <label>Type </label>
                                    <FormControl fullWidth>
                                        <Select
                                            value={category}
                                            onChange={handleCategoryChange}
                                            displayEmpty
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            className="event-category-dropdown"
                                            IconComponent={CustomDropdownIcon}
                                            //error={!!groupTypeError.current}
                                        >
                                            <MenuItem className="group-type-menu" value="">
                                                <em>Select Group Type</em>
                                            </MenuItem>
                                            <MenuItem className="group-type-menu" value="Association">Association</MenuItem>
                                            <MenuItem className="group-type-menu" value="Social">Social</MenuItem>
                                            <MenuItem className="group-type-menu" value="Military">Military</MenuItem>
                                            <MenuItem className="group-type-menu" value="Government">Government</MenuItem>
                                            <MenuItem className="group-type-menu" value="Religious">Religious</MenuItem>
                                            <MenuItem className="group-type-menu" value="Fraternity">Fraternity</MenuItem>
                                            <MenuItem className="group-type-menu" value="Corporate">Corporate</MenuItem>
                                            <MenuItem className="group-type-menu" value="Educational">Educational</MenuItem>
                                            <MenuItem className="group-type-menu" value="Leisure Tours & Travels">Leisure Tours & Travels</MenuItem>
                                            <MenuItem className="group-type-menu" value="Contract">Contract</MenuItem>
                                            <MenuItem className="group-type-menu" value="Other">Other</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box item>
                                    <div className='top-bar-item'>
                                        <label>Check-In & Check-Out Date</label>
                                        <TextField
                                            inputRef={calendarRef}
                                            tabIndex={1}
                                            onKeyDown={preventTyping}
                                            onClick={toggleDateRangePickerVisiblity}
                                            style={{ cursor: "pointer" }}
                                            fullWidth
                                            className={dateRangePickerVisiblity ? 'text-field vijay date-range-picker-active' : "text-field vijay"}
                                            size="small"
                                            value={dateFormat(arrivalDate, "ddd, MMM DD YYYY") + " - " + dateFormat(departureDate, "ddd, MMM DD YYYY")}
                                            InputProps={{
                                                endAdornment: (
                                                    <IconButton onClick={toggleDateRangePickerVisiblity} edge="end">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#00415F" viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z"></path></svg>
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </div>
                                </Box>
                                <Box item
                                    className={
                                        dateRangePickerVisiblity ? "date-range-picker-container" : "date-range-picker-container-false"
                                    }
                                    style={{ marginTop: '20px', marginRight: '20px' }}
                                >
                                    <div className='top-bar-item'>
                                        <DateRangePicker
                                            showSelectionPreview={true}
                                            moveRangeOnFirstSelection={false}
                                            months={2}
                                            direction="horizontal"
                                            className="group-iq-datepicker"
                                            ranges={[
                                                {
                                                    startDate: new Date(arrivalDateTemp),
                                                    endDate: new Date(departureDateTemp),
                                                    key: 'selection',
                                                },
                                            ]}
                                            minDate={new Date(as_of_date)} // disabled previous date from current date
                                            onChange={(ranges) => {
                                                // Update arrival and departure dates based on user selection
                                                setArrivalDateTemp(ranges.selection.startDate);
                                                setDepartureDateTemp(ranges.selection.endDate);
                                            }}
                                            dayContentRenderer={(date) => {
                                                const blackoutDatesSet = new Set(blackout.map(date => new Date(date).toDateString()));
                                                const isBlackout = blackoutDatesSet.has(date.toDateString());
                                                return (
                                                    isBlackout ? (
                                                        <Tooltip title="Blackout Date" placement="top" arrow>
                                                            <span className="blackout">
                                                                {date.getDate()}
                                                            </span>
                                                        </Tooltip>
                                                    ) : (
                                                        <span>
                                                            {date.getDate()}
                                                        </span>
                                                    )
                                                );
                                            }}
                                        />
                                        <Box sx={{ background: "#FFF" }} className="datepicker-done-btn"><Button onClick={toggleDateRangePickerVisiblity}>Done</Button></Box>
                                    </div>
                                </Box>
                            </Box>

                            <Box className={`tabular-data ${showAllContainers ? 'tabular-data-view-only' : ''}`}>
                                <Box mb={1.5} mt={showAllContainers && !compState.error ? 0 : 1.5}>
                                    <Tabs value={value} onChange={handleChange} className="tabs-wrap" aria-label="basic tabs example">
                                        <Tab className='group-pricing-tabs' label="Room Block*" {...a11yProps(0)} />
                                        <Tab className='group-pricing-tabs' label="Ancillary Rev" {...a11yProps(1)} />
                                    </Tabs>
                                </Box>
                                <TabPanel className="tab-content room-block" value={value} index={0}>
                                    <div className='tab-content-root'>
                                        <RoomBlock Smart={Smart}
                                            otbRmType={deepCopy(otbRmType.current)}
                                            totalCapacity={totalCapacity}
                                            arrivalDate={arrivalDate}
                                            departureDate={departureDate}
                                            collectTabData={collectRoomBlockTabData}
                                            tabData={roomBlockTabData}
                                            footerData={revenueModifier}

                                        />
                                    </div>
                                </TabPanel>
                                <TabPanel className="tab-content " value={value} index={1}>
                                    <div className='tab-content-root' >
                                        <AncilleryRev
                                            Smart={Smart}
                                            arrivalDate={arrivalDate}
                                            departureDate={departureDate}
                                            collectTabData={collectAncillaryRevTabData}
                                            tabData={ancillaryRevTabData}
                                            footerData={profitMargins}
                                        />
                                    </div>
                                </TabPanel>

                            </Box>

                            <div className="group-iq-bottom-bar">
                                <Alert
                                    severity="error"
                                    className="save-changes-alert display-none"
                                    sx={{ padding: "0px 12px", margin: "0px 16px" }}
                                >
                                    {alertText}
                                </Alert>
                                {!isSubmitting ?
                                    <Button
                                        onClick={() => {
                                            setTimeout(() => {
                                                handleSubmit();
                                            }, 100);
                                        }}
                                        variant="outlined"
                                        size="small"
                                        className="navigate-save-button btn-active"
                                        sx={{ minWidth: "auto", lineHeight: "unset" }}
                                    >
                                        Submit
                                    </Button>
                                    :
                                    <Button
                                        disabled
                                        variant="outlined"
                                        size="small"
                                        className="navigate-save-button btn-active"
                                        sx={{ minWidth: "auto", lineHeight: "unset", gap: 1, pointerEvents: "none", width: "90.16px", height: "31.59px" }}
                                    >
                                        <CircularProgress
                                            color="inherit"
                                            size={16}
                                        />
                                    </Button>
                                }
                            </div>

                        </Box>

                    }
                </Box>

                <Modal
                    open={openSetting}
                    onClose={handleCloseSetting}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className="add-event-popup settings main-popup" sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '900px',
                        height: '762px',
                        bgcolor: '#fff',
                        boxShadow: 24, borderRadius: '8px',
                    }}>
                        <div className="pop-up-header clearfix request-popup-header">
                            <Box sx={{ float: 'left' }}>
                                <div className="tile-title" data-tile-icon="icon-icon-events" data-id="events">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm109.94-52.79a8,8,0,0,0-3.89-5.4l-29.83-17-.12-33.62a8,8,0,0,0-2.83-6.08,111.91,111.91,0,0,0-36.72-20.67,8,8,0,0,0-6.46.59L128,41.85,97.88,25a8,8,0,0,0-6.47-.6A112.1,112.1,0,0,0,54.73,45.15a8,8,0,0,0-2.83,6.07l-.15,33.65-29.83,17a8,8,0,0,0-3.89,5.4,106.47,106.47,0,0,0,0,41.56,8,8,0,0,0,3.89,5.4l29.83,17,.12,33.62a8,8,0,0,0,2.83,6.08,111.91,111.91,0,0,0,36.72,20.67,8,8,0,0,0,6.46-.59L128,214.15,158.12,231a7.91,7.91,0,0,0,3.9,1,8.09,8.09,0,0,0,2.57-.42,112.1,112.1,0,0,0,36.68-20.73,8,8,0,0,0,2.83-6.07l.15-33.65,29.83-17a8,8,0,0,0,3.89-5.4A106.47,106.47,0,0,0,237.94,107.21Zm-15,34.91-28.57,16.25a8,8,0,0,0-3,3c-.58,1-1.19,2.06-1.81,3.06a7.94,7.94,0,0,0-1.22,4.21l-.15,32.25a95.89,95.89,0,0,1-25.37,14.3L134,199.13a8,8,0,0,0-3.91-1h-.19c-1.21,0-2.43,0-3.64,0a8.08,8.08,0,0,0-4.1,1l-28.84,16.1A96,96,0,0,1,67.88,201l-.11-32.2a8,8,0,0,0-1.22-4.22c-.62-1-1.23-2-1.8-3.06a8.09,8.09,0,0,0-3-3.06l-28.6-16.29a90.49,90.49,0,0,1,0-28.26L61.67,97.63a8,8,0,0,0,3-3c.58-1,1.19-2.06,1.81-3.06a7.94,7.94,0,0,0,1.22-4.21l.15-32.25a95.89,95.89,0,0,1,25.37-14.3L122,56.87a8,8,0,0,0,4.1,1c1.21,0,2.43,0,3.64,0a8.08,8.08,0,0,0,4.1-1l28.84-16.1A96,96,0,0,1,188.12,55l.11,32.2a8,8,0,0,0,1.22,4.22c.62,1,1.23,2,1.8,3.06a8.09,8.09,0,0,0,3,3.06l28.6,16.29A90.49,90.49,0,0,1,222.9,142.12Z"></path></svg>
                                    <div className="tile-name">Settings</div>
                                </div>
                            </Box>
                            <Box sx={{ float: 'right' }}>
                                <Button className='cross-btn'
                                    sx={{
                                        minWidth: 'auto', width: '22px', height: '22px', p: '7px', borderRadius: '50%', backgroundColor: 'black', color: 'white', fontSize: '10px', '&:hover': { background: '#000' }
                                    }} onClick={handleCloseSetting}>
                                    <CloseSharpIcon fontSize='small' background="black" />
                                </Button>
                            </Box>
                        </div>

                        <Box className="tabular-data">

                            <Tabs className="tabs-wrap" value={openSettingTabValue} onChange={settingTabChange} aria-label="basic tabs example">
                                <Tab className="group-pricing-tabs" label="Demand Seasons" {...a11yProps(0)} />
                                <Tab className="group-pricing-tabs" label="Blackout Dates" {...a11yProps(1)} />
                            </Tabs>


                            {/* Demand Seasons Tab */}
                            <CustomTabPanel className="tab-content" value={openSettingTabValue} index={0}>
                                <DemandSeasons
                                    openSetting={openSetting}
                                    openSettingTabValue={openSettingTabValue}
                                    openDefault={openDefault}
                                />
                            </CustomTabPanel>

                            {/* Blackout Dates */}
                            <CustomTabPanel className="tab-content blackout-dates" value={openSettingTabValue} index={1}>
                                <BlackoutDates openSettingTabValue={openSettingTabValue} openDefault={openDefault} />
                            </CustomTabPanel>

                        </Box>

                    </Box>

                </Modal>

                <Modal
                    open={openDefaultSetupAlert}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className="add-event-popup settings" sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '590px',
                        height: '224px',
                        bgcolor: '#fff',
                        boxShadow: 24, borderRadius: '8px',
                        display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#B2B2B2" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path></svg>
                            <Box sx={{ textAlign: "center", lineHeight: "1.8", fontSize: "16px", fontFamily: "SFUI Regular" }}>
                                <div>Before You Can Start Using Group IQ, Let's Set up Your Default Settings.</div>
                                <div>This is a one-Time Setup to Get You Started.</div>
                            </Box>
                            <Box className="create-demand-action-btns" sx={{ paddingTop: "8px !important", width: "100%" }}>
                                <Button
                                    //disabled={!isChangeRequest}
                                    onClick={goBackToDashboard}
                                    variant="outlined"
                                    className="navigate-cancel-button btn-active"
                                    size="small"
                                    sx={{ minWidth: "auto", lineHeight: "unset" }}
                                >
                                    Back to Dashboard
                                </Button>
                                <Button
                                    //disabled={!isChangeRequest}
                                    onClick={() => {
                                        handleContinueDefaultSetup();
                                    }}
                                    variant="outlined"
                                    size="small"
                                    className="navigate-save-button btn-active"
                                    sx={{ minWidth: "auto", lineHeight: "unset" }}
                                >
                                    Continue
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>

                <Modal
                    open={submitAnyway}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className="add-event-popup settings" sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '596px',
                        height: '180px',
                        bgcolor: '#fff',
                        boxShadow: 24, borderRadius: '8px',
                        display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                        
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                            <Box sx={{ textAlign: "center", lineHeight: "1.8", fontSize: "16px", fontFamily: "SFUI Regular" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#B2B2B2" viewBox="0 0 256 256"><path d="M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z"></path></svg>
                                <div>The Stay Period You Have Selected Includes Blackout Dates.</div>
                            </Box>
                            <Box className="create-demand-action-btns" sx={{ paddingTop: "8px !important", justifyContent: "end !important", width: "100%" }}>
                                <Button
                                    disabled={isSubmittingAnyway}
                                    onClick={cancelSubmitAnyway}
                                    variant="outlined"
                                    className="navigate-cancel-button btn-active"
                                    size="small"
                                    sx={{ minWidth: "auto", lineHeight: "unset" }}
                                >
                                    Cancel
                                </Button>
                                {!isSubmittingAnyway ?
                                    <Button
                                        onClick={() => {
                                            handleSubmitAnyway();
                                        }}
                                        variant="outlined"
                                        size="small"
                                        className="navigate-save-button btn-active"
                                        sx={{ minWidth: "auto", lineHeight: "unset" }}
                                    >
                                        Submit Anyway
                                    </Button>
                                    :
                                    <Button
                                        disabled
                                        variant="outlined"
                                        size="small"
                                        className="navigate-save-button btn-active"
                                        sx={{ minWidth: "auto", lineHeight: "unset", gap: 1, pointerEvents: "none", width: "141.29px", height: "30.2px" }}
                                    >
                                        <CircularProgress
                                            color="inherit"
                                            size={16}
                                        />
                                    </Button>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Modal>
                <Modal
                    open={groupTypeNamePopupOpen}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className="add-group-name-type-popup settings" sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '596px',
                        bgcolor: '#fff',
                        boxShadow: 24, 
                        borderRadius: '8px',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        {/* X button in top right */}
                        <div className="pop-up-header clearfix request-popup-header">
                            <Box sx={{ float: 'left' }}>
                                <div className="tile-title" data-tile-icon="icon-icon-events" data-id="events">
                                    <span className="tile-icon">
                                        <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 1.6875C7.55373 1.6875 6.13993 2.11637 4.9374 2.91988C3.73486 3.72339 2.7976 4.86544 2.24413 6.20163C1.69067 7.53781 1.54586 9.00811 1.82801 10.4266C2.11017 11.8451 2.80661 13.148 3.82928 14.1707C4.85196 15.1934 6.15492 15.8898 7.57341 16.172C8.99189 16.4541 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3105 7.06123 15.5394 5.20246 14.1685 3.83154C12.7975 2.46063 10.9388 1.68955 9 1.6875ZM9 15.1875C7.77623 15.1875 6.57994 14.8246 5.56241 14.1447C4.54488 13.4648 3.75182 12.4985 3.2835 11.3679C2.81518 10.2372 2.69265 8.99314 2.93139 7.79288C3.17014 6.59262 3.75944 5.49011 4.62478 4.62478C5.49012 3.75944 6.59262 3.17014 7.79288 2.93139C8.99314 2.69264 10.2372 2.81518 11.3679 3.2835C12.4985 3.75181 13.4648 4.54488 14.1447 5.56241C14.8246 6.57994 15.1875 7.77623 15.1875 9C15.1856 10.6405 14.5331 12.2132 13.3732 13.3732C12.2132 14.5331 10.6405 15.1856 9 15.1875ZM8.4375 9.5625V5.625C8.4375 5.47582 8.49677 5.33274 8.60226 5.22725C8.70775 5.12176 8.85082 5.0625 9 5.0625C9.14919 5.0625 9.29226 5.12176 9.39775 5.22725C9.50324 5.33274 9.5625 5.47582 9.5625 5.625V9.5625C9.5625 9.71168 9.50324 9.85476 9.39775 9.96025C9.29226 10.0657 9.14919 10.125 9 10.125C8.85082 10.125 8.70775 10.0657 8.60226 9.96025C8.49677 9.85476 8.4375 9.71168 8.4375 9.5625ZM9.84375 12.0938C9.84375 12.2606 9.79427 12.4238 9.70156 12.5625C9.60884 12.7013 9.47707 12.8094 9.32289 12.8733C9.16872 12.9371 8.99907 12.9538 8.8354 12.9213C8.67172 12.8887 8.52138 12.8084 8.40338 12.6904C8.28538 12.5724 8.20502 12.422 8.17247 12.2584C8.13991 12.0947 8.15662 11.925 8.22048 11.7709C8.28434 11.6167 8.39249 11.4849 8.53124 11.3922C8.66999 11.2995 8.83313 11.25 9 11.25C9.22378 11.25 9.43839 11.3389 9.59662 11.4971C9.75486 11.6554 9.84375 11.87 9.84375 12.0938Z" fill="white"/>
                                        </svg> 
                                    </span>                                    
                                    <span className="tile-name">Required Fields</span>
                                </div>
                            </Box>
                            <Box sx={{ float: 'right' }}>
                                <Button className='cross-btn'
                                    sx={{
                                        minWidth: 'auto', borderRadius: '50%', backgroundColor: 'black', color: 'white', fontSize: '10px', '&:hover': { background: '#000' }
                                    }} 
                                    onClick={() => {
                                        setGroupName(responseFromAPI.params_called_with.group_name);
                                        setCategory(responseFromAPI.params_called_with.type);
                                        setIsGroupTypeNameChanged(false)
                                        setGroupNameTypePopupOpen(false);
                                    }}
                                >
                                    <CloseSharpIcon fontSize='small' background="black" />
                                </Button>
                            </Box>
                        </div>
                        
                        {/* Content */}
                        <Box className="request-popup-body-content">
                            <div className="notice-text">
                                <svg width="16" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.6875 3.3125C5.56262 3.3125 4.463 3.64607 3.5277 4.27102C2.59239 4.89597 1.86341 5.78423 1.43294 6.82349C1.00246 7.86274 0.889833 9.00631 1.10929 10.1096C1.32874 11.2128 1.87042 12.2263 2.66583 13.0217C3.46124 13.8171 4.47466 14.3588 5.57793 14.5782C6.68119 14.7977 7.82476 14.685 8.86401 14.2546C9.90327 13.8241 10.7915 13.0951 11.4165 12.1598C12.0414 11.2245 12.375 10.1249 12.375 9C12.3734 7.49207 11.7737 6.04636 10.7074 4.98009C9.64115 3.91382 8.19543 3.31409 6.6875 3.3125ZM6.6875 13.8125C5.73568 13.8125 4.80523 13.5303 4.01382 13.0014C3.22241 12.4726 2.60558 11.721 2.24133 10.8417C1.87709 9.9623 1.78178 8.99466 1.96747 8.06113C2.15316 7.12759 2.61151 6.27009 3.28455 5.59705C3.95759 4.92401 4.8151 4.46566 5.74863 4.27997C6.68216 4.09428 7.6498 4.18958 8.52917 4.55383C9.40854 4.91808 10.1601 5.53491 10.6889 6.32632C11.2178 7.11773 11.5 8.04818 11.5 9C11.4986 10.2759 10.9911 11.4991 10.0889 12.4014C9.18665 13.3036 7.96341 13.8111 6.6875 13.8125ZM7.5625 11.625C7.5625 11.741 7.51641 11.8523 7.43436 11.9344C7.35231 12.0164 7.24103 12.0625 7.125 12.0625C6.89294 12.0625 6.67038 11.9703 6.50628 11.8062C6.34219 11.6421 6.25 11.4196 6.25 11.1875V9C6.13397 9 6.02269 8.95391 5.94064 8.87186C5.8586 8.78981 5.8125 8.67853 5.8125 8.5625C5.8125 8.44647 5.8586 8.33519 5.94064 8.25314C6.02269 8.17109 6.13397 8.125 6.25 8.125C6.48207 8.125 6.70463 8.21719 6.86872 8.38128C7.03281 8.54538 7.125 8.76794 7.125 9V11.1875C7.24103 11.1875 7.35231 11.2336 7.43436 11.3156C7.51641 11.3977 7.5625 11.509 7.5625 11.625ZM5.8125 6.59375C5.8125 6.46396 5.85099 6.33708 5.9231 6.22916C5.99521 6.12124 6.0977 6.03712 6.21762 5.98745C6.33753 5.93778 6.46948 5.92479 6.59678 5.95011C6.72408 5.97543 6.84101 6.03793 6.93279 6.12971C7.02457 6.22149 7.08707 6.33842 7.11239 6.46572C7.13771 6.59302 7.12472 6.72497 7.07505 6.84489C7.02538 6.9648 6.94127 7.06729 6.83335 7.1394C6.72543 7.21151 6.59855 7.25 6.46875 7.25C6.2947 7.25 6.12778 7.18086 6.00471 7.05779C5.88164 6.93472 5.8125 6.7678 5.8125 6.59375Z" fill="#606060" />
                                </svg>
                                <div className="text">To save the group quote, enter the Group Name and Group Type.</div>
                            </div>
                            
                            {/* Form fields side by side */}
                            <Box className="group-name-type-inputs">
                                <Box className="group-name-type-popup-content">
                                    <label>Name*</label>
                                    <TextField 
                                        tabIndex={1} 
                                        className='text-field group-name' 
                                        value={groupName} 
                                        onChange={(e) => {
                                            setGroupName(e.target.value)
                                            setIsGroupTypeNameChanged(true)
                                        }}
                                        fullWidth 
                                        size='small' 
                                        placeholder='Group Name' 
                                        autoFocus 
                                        //error={!!groupNameError.current} 
                                    />
                                </Box>
                                <Box className="group-name-type-popup-content">
                                    <label>Type*</label>
                                    <FormControl fullWidth>
                                        <Select
                                            value={category}
                                            //onChange={handleCategoryChange}
                                            onChange={(e) => {
                                                setCategory(e.target.value);
                                                setIsGroupTypeNameChanged(true)
                                            }}
                                            displayEmpty
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            className="event-category-dropdown"
                                            IconComponent={CustomDropdownIcon}
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                },
                                                transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left",
                                                },
                                                getContentAnchorEl: null,
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 350, // Set max height for dropdown
                                                        overflowY: "auto", // Enable scrolling
                                                    },
                                                },
                                            }}
                                        >
                                            <MenuItem className="group-type-menu" value="">
                                                <em>Select Group Type</em>
                                            </MenuItem>
                                            <MenuItem className="group-type-menu" value="Association">Association</MenuItem>
                                            <MenuItem className="group-type-menu" value="Social">Social</MenuItem>
                                            <MenuItem className="group-type-menu" value="Military">Military</MenuItem>
                                            <MenuItem className="group-type-menu" value="Government">Government</MenuItem>
                                            <MenuItem className="group-type-menu" value="Religious">Religious</MenuItem>
                                            <MenuItem className="group-type-menu" value="Fraternity">Fraternity</MenuItem>
                                            <MenuItem className="group-type-menu" value="Corporate">Corporate</MenuItem>
                                            <MenuItem className="group-type-menu" value="Educational">Educational</MenuItem>
                                            <MenuItem className="group-type-menu" value="Leisure Tours & Travels">Leisure Tours & Travels</MenuItem>
                                            <MenuItem className="group-type-menu" value="Contract">Contract</MenuItem>
                                            <MenuItem className="group-type-menu" value="Other">Other</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>
                            
                            {/* Buttons at bottom */}
                            <Box className="create-demand-action-btns" sx={{ 
                                paddingTop: "8px !important", 
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "8px",
                                padding: "0 20px 10px"
                            }}>
                                <Button
                                    disabled={!isGroupTypeNameChanged}
                                    onClick={() => {
                                        setGroupName(responseFromAPI.params_called_with.group_name);
                                        setCategory(responseFromAPI.params_called_with.type);
                                        setIsGroupTypeNameChanged(false)
                                        //setGroupNameTypePopupOpen(false);
                                    }}
                                    variant="outlined"
                                    className="navigate-cancel-button btn-active"
                                    size="small"
                                    sx={{ minWidth: "auto", lineHeight: "unset" }}
                                >
                                    Discard Changes
                                </Button>
                                <Button
                                    disabled={groupName.trim() === "" || category.trim() === ""}
                                    onClick={() => {
                                        // Validate inputs before closing
                                        const isGroupNameEmpty = groupName.trim() === "";
                                        const isCategoryEmpty = category.trim() === "";

                                        // Close the popup only if there are no errors
                                        if (!isGroupNameEmpty && !isCategoryEmpty) {
                                            setGroupNameTypePopupOpen(false);
                                            handleSaveQuote();
                                        }
                                    }}
                                    variant="outlined"
                                    size="small"
                                    className="navigate-save-button btn-active"
                                    sx={{ minWidth: "auto", lineHeight: "unset" }}
                                >
                                    Save
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
                
                <DashboardFooter />

            </div>
        </AtuoLogoutTimer>
    )
}

export {
    GroupIQ
}